module.exports = __webpack_public_path__ + "img/postit_complete_426x426.d73b65b3.png";